export const siteLinks = {
    about: `//${process.env.REACT_APP_BASE_DOMAIN}/findall/about`,
    career: `//${process.env.REACT_APP_BASE_DOMAIN}/career`,
    gallery: `//${process.env.REACT_APP_BASE_DOMAIN}/findall/gallery`,
    advertising: `//${process.env.REACT_APP_BASE_DOMAIN}/advertising`,
    privacy: `//${process.env.REACT_APP_BASE_DOMAIN}/privacy-policy`,
    terms: `//${process.env.REACT_APP_BASE_DOMAIN}/terms-of-services`,
}